import React from 'react';
import Button from 'shared/components/button/Button';
import { randomInt } from 'utils/numbers';
import { MOOD_POLL_KEY } from 'utils/constants/messages';

const MessageOptions = ({ chatPresets, sendMessage }) => {
  const handleClick = (key, arr) => {
    sendMessage(
      arr[randomInt(arr.length)],
      key === MOOD_POLL_KEY ? { [MOOD_POLL_KEY]: true } : {}
    );
  };

  return (
    <div className="message-options">
      {Object.entries(chatPresets).map(([key, val]) => (
        <div key={key}>
          <Button
            color="secondary"
            btnBlock="block"
            label={key}
            onClick={() => handleClick(key, val)}
          />
        </div>
      ))}
    </div>
  );
};

export default MessageOptions;
